/**
 * The calendar date (YYYY-MM-DD) an instant falls on in this browser's time zone.
 * @param {Date | number | string} instant
 * @returns {string}
 */
export const localDateOf = (instant) => {
  const d = new Date(instant);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/**
 * Today in the viewer's time zone. Not `toISOString()`, which is UTC's date: on an AU
 * morning that is still yesterday.
 * @returns {string}
 */
export const todayLocalISO = () => localDateOf(Date.now());
